<template>
  <div class="page" :style="{ height: pageHeight + 'px' }">
    <div class="page-wraper" :style="{ height: pageHeight - 50 + 'px' }">
      <!-- <index v-if="active==0"></index>
      <mine v-if="active==1"></mine> -->
      <router-view></router-view>
    </div>
    <div class="tab-bar">
      <van-tabbar v-model="active">
        <van-tabbar-item>
          <span :class="{ active: active == 0 }">投保</span>
          <template #icon="props">
            <img :src="props.active ? touIcon.active : touIcon.inactive" />
          </template>
        </van-tabbar-item>
        <van-tabbar-item>
          <span :class="{ active: active == 1 }">我的</span>
          <template #icon="props">
            <img :src="props.active ? wodIcon.active : wodIcon.inactive" />
          </template>
        </van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
import storejs from "store";
import util from "@/libs/util.js";
import moment from "moment";
import { Dialog, Tabbar, TabbarItem } from "vant";
import wechatService from "@/services/request/wechatService.js";
import $ from "jquery";
import toub from "./assets/img/toub@2x.png";
import toubl from "./assets/img/toubl@2x.png";
import wod from "./assets/img/wod@2x.png";
import wodl from "./assets/img/wodl@2x.png";

import index from "../index/index.vue";
import mine from "../mine/index.vue";

export default {
  name: "Mine",
  components: {
    index,
    mine,
    Dialog,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
  },
  data() {
    return {
      moment: moment,
      publicData: storejs.get("publicData"),
      pageHeight: window.innerHeight,
      active: 0,
      touIcon: {
        active: toubl,
        inactive: toub,
      },
      wodIcon: {
        active: wodl,
        inactive: wod,
      },
    };
  },
  watch: {
    active: function (val) {
      console.log("active", this.active);
      storejs.set('tabActive',val)
      this.changeRoute()
    },
  },
  mounted() {
    console.log('$route',this.$route)
    if(storejs.get('tabActive')){
      this.active = storejs.get('tabActive')
    }
    this.changeRoute()
    
  },
  beforeDestroy: function () {},
  methods: {
    changeRoute(){
      if (this.active == 0) {
        this.$router.push({
          name: "TabIndex",
          query:{
            t:new Date().getTime()
          }
        });
      }
      if (this.active == 1) {
        this.$router.push({
          name: "TabMine",
          query:{
            t:new Date().getTime()
          }
        });
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.page {
  .page-wraper {
    overflow-y: scroll;
  }
  .tab-bar {
    span {
      font-size: 0.1rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      &.active {
        font-size: 0.1rem;
        font-family: PingFang SC;
        font-weight: 600;
        color: #2dd97a;
      }
    }
  }
}
</style>

<style lang="scss">
.page {
  .van-field {
    .label-css {
      font-size: 0.12rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: #2dd97a;
    }
  }
}
</style>